// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/content-documents/shared/author/author.component.scss
// module id = 179
// module chunks = 0